import clsx from 'clsx';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { Fade } from '../Fade';
import { Text } from '../Text';
import styles from './Alert.module.scss';
type Props = {
  isOpen?: boolean;
  text: string;
};
export const RenderAlert = ({
  isOpen = false,
  text
}: Props) => {
  const ref = useRef(null);
  if (typeof window === 'undefined') return null;
  return createPortal(<Fade isActive={isOpen} nodeRef={ref}>
      <Text className={clsx(styles.wrapper)} type='p3'>
        {text}
      </Text>
    </Fade>, document.body);
};